import { useContext, useEffect, useReducer, useState } from "react"
import { Token } from "../Model/Token"
import { Post } from "../Rutas/ApiRest"
import { Toke } from "../Rutas/Servicios"
import { tokens } from "./Tokens"

const Tiempo=3600000
const link=Toke.tokes;
var raw = "userName=algo@algo.cl&password=1234&grant_type=password";
const token:Token=
    {
        access_token:"d",
        token_type:"",
        fecha:0
    }

interface props{
    children:JSX.Element | JSX.Element[]
}

export const ProviderTokens=({children}:props)=>
{  
    const [tok,SetToke]=useState<Token>(token)
    const [tiempo,setTiempo]=useState<number>(0)
      
    const toggleTodo=()=>
    {
        if(tiempo==0)
        {
            setTiempo(Date.now()+Tiempo)
            const dato= Post(link,raw,"text/plain","")
        
            dato.then((e:Token)=>{SetToke((e));return e})
            return dato.then(resut=>{return resut});
        }else
        {
            if(tiempo<=Date.now())
            {
                SetToke({access_token:"",
                token_type:"",
                fecha:1})
                window.location.href="https://apps.eshopex.cl/";
            }
        }
        
    }

    return(
        <tokens.Provider value={{tok,toggleTodo}}>
            {children}
        </tokens.Provider>
    )
    
}

